export type ExportFormat = 'png' | 'tiff' | 'pdf' | 'eps';

interface Recommendation {
  format: ExportFormat;
  reason: string;
  prefix?: string;
}

// Mapeamento por pro_id (preencha conforme catálogo)
// Exemplo: { 101: { format: 'tiff', reason: 'DTF TÊXTIL', prefix: 'DTF' } }
// Regras centrais por pro_id (fácil de editar/expandir)
export const PRO_ID_RECOMMENDATIONS: Record<number, Recommendation> = {
  // TIFF (DTF)
  4: { format: 'tiff', reason: 'DTF UV - pro_id 4', prefix: 'DTF UV' },
  5: { format: 'tiff', reason: 'DTF Têxtil - pro_id 5', prefix: 'DTF TÊXTIL' },
  
  // PDF (Sublimação)
  6: { format: 'pdf', reason: 'Sublimação - pro_id 6', prefix: 'SUBLIMAÇÃO' },
  
  // Adicione outros pro_ids conforme necessário
  // 7: { format: '...', reason: '...' },
};

// Fallback por nome do produto (case-insensitive, inclui aproximações)
export function getRecommendationByName(productName?: string): Recommendation | null {
  if (!productName) return null;
  const name = String(productName).toLowerCase();
  if (name.includes('dtf') && name.includes('uv')) {
    return { format: 'tiff', reason: 'DTF UV', prefix: 'DTF UV' };
  }
  if (name.includes('dtf')) {
    return { format: 'tiff', reason: 'DTF Têxtil', prefix: 'DTF TÊXTIL' };
  }
  if (name.includes('sublim')) {
    return { format: 'pdf', reason: 'Sublimação', prefix: 'SUBLIMAÇÃO' };
  }
  if (name.includes('adesiv')) {
    return { format: 'eps', reason: 'Adesivo', prefix: 'ADESIVO UV' };
  }
  return null;
}

export function getRecommendation(params: { proId?: number | null; productName?: string | null }): Recommendation | null {
  const { proId, productName } = params;
  if (typeof proId === 'number' && PRO_ID_RECOMMENDATIONS[proId]) {
    return PRO_ID_RECOMMENDATIONS[proId];
  }
  const byName = getRecommendationByName(productName ?? undefined);
  return byName;
}


